import type { SignoutRedirectArgs } from "oidc-client-ts";
import { clearNewRelicSession } from "@/config/newrelic/session";
import { resetSupportModeStore } from "@/store/useSupportModeStore";
import { clearSupportAdminAuthFlagFromStorage } from "@/store/supportAdminAuthStorage";
import { clearStoredTrimblePkceVerifier } from "@/utils/silentTokenRefresh";

type SignOutRedirect = (args?: SignoutRedirectArgs) => Promise<void>;

export function prepareAuthSignOut(): void {
  clearStoredTrimblePkceVerifier();
  resetSupportModeStore();
  clearSupportAdminAuthFlagFromStorage();
  clearNewRelicSession();
}

export async function authSignOutRedirect(
  signoutRedirect: SignOutRedirect,
  args?: SignoutRedirectArgs
): Promise<void> {
  prepareAuthSignOut();
  await signoutRedirect(args);
}
